module.exports = new __parcel__URL__("en_assets.49055197.png").toString();